<script lang="ts">
  import TextNew from "../../TextNew.svelte";

  export let title: string;
</script>

<div class="container">
  <p class="quote-top">“</p>

  <slot />

  <TextNew size="s">{title}</TextNew>

  <p class="quote-bottom">”</p>
</div>

<style>
  .container {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;
    background-color: var(--rk-neutral-0);
    border: 1px solid var(--rk-divider-0);
    border-radius: 8px;
    position: relative;
    padding: 38px 24px;
    text-align: center;
  }
  .quote-top,
  .quote-bottom {
    position: absolute;
  }

  .quote-top,
  .quote-bottom {
    font-family: "REKKI-Regular";
    font-size: 68px;
    line-height: 76px;
    font-weight: 500;
    color: var(--rk-divider-0);
  }

  .quote-top {
    top: 0;
    left: 10px;
  }

  .quote-bottom {
    bottom: -34px;
    right: 10px;
  }
</style>
